<div class="flex-container-column-center height-100 bg-auth-accent">
	<div class="width-100 flex-container-row-nowrap justify-content-space-between box-sizing-border-box">
		<button class="button-reset btn--text padding-16px color-light-gray-on-accent" (click)="cancel()">
			<i aria-hidden="true" class="fa fa-arrow-left"></i>
		</button>
		<ic-change-language class="margin-top-4px margin-right-8px color-light-gray-on-accent" />
	</div>
	<form autocomplete="off" class="margin-top-auto" novalidate [formGroup]="form">
		<fieldset>
			<ic-form-field class="auth__token">
				<span icLabel>
					{{ "auth.token" | translate }}
				</span>

				<input data-test="mfa-token-input" formControlName="token" icInput name="token" type="number" />

				<span class="fa fa-mobile" icPrefix></span>

				@if (hasTokenError) {
					<ic-error>
						{{ "auth.validators.token_required" | translate }}
					</ic-error>
				}
			</ic-form-field>

			<input
				data-test="submit-button"
				type="submit"
				value="{{ 'auth.signin' | translate }}"
				(click)="sendToken(form.value)"
			/>
		</fieldset>
	</form>
	<div
		class="width-100 text-align-center font-size-0-8rem color-light-gray-on-accent margin-top-auto margin-bottom-1rem"
	>
		{{ "settings.version" | translate }} {{ appVersion }}
	</div>
</div>
